export default (str, visibleCount = 4, maskChar = '*') => {
  if (typeof str !== 'string') return '';
  if (str.length <= visibleCount) return str;

  const maskedPart = maskChar.repeat(str.length - visibleCount);
  const visiblePart = str.slice(-visibleCount);
  return maskedPart + visiblePart;
}